import React, { useContext, useEffect, useState } from "react";
import { injectIntl } from "react-intl";

import { useIsVisible } from "../../Base/Hooks/IsVisible";
import { useDoActions } from "../../Base/Hooks/doActions";
import { FixtureDetailsContext } from "../../../Config/FixtureDetails";
import { allowedValues } from "./MiniLocationConfig";
import PositionHelper from "../../Base/Utilities/PositionHelper";

import "./MiniLocation.scss";

const MiniLocation = (props) => {
  const { panel, updateState, currentState, intl } = props;
  const { formatMessage } = intl;
  const [isVisible, isEnabled] = useIsVisible(panel, props);
  const { sport } = useContext(FixtureDetailsContext);
  const [doAction, setDoAction] = useState(false);
  const [events, setEvents] = useState();
  const [position, setPosition] = useState();
  const [positionSelected, setPositionSelected] = useState(false);
  const [actionsDone] = useDoActions(panel, props, doAction);

  useEffect(() => {
    if (actionsDone) {
      setDoAction(false);
    }
    // eslint-disable-next-line
  }, [actionsDone]);

  useEffect(() => {
    setEvents(currentState.events);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const posX = currentState.events?.edit?.x ?? "0";
    const posY = currentState.events?.edit?.y ?? "0";
    const actionPosition = PositionHelper.transformViewGamePosition(posX, posY, currentState.entities);
    setPosition({ x: actionPosition.x, y: actionPosition.y });
  }, []);

  useEffect(() => {
    if (position && events && positionSelected && !panel.options?.needConfirmation) {
      handleDone();
    }
    // eslint-disable-next-line
  }, [position]);

  function checkAllowedValues(event) {
    Object.keys(event.options).forEach((option) => {
      if (!allowedValues[event.eventType].options.includes(option)) {
        delete event.options[option];
      }
    });
    if (!allowedValues[event.eventType].subTypes.includes(event.subType)) {
      delete event.subType;
    }
    return event;
  }

  function getPos(e) {
    const posX = parseFloat(((e.nativeEvent.offsetX / e.target.offsetWidth) * 100).toFixed(2));
    const posY = parseFloat(((e.nativeEvent.offsetY / e.target.offsetHeight) * 100).toFixed(2));
    setPositionSelected(true);
    setPosition({ x: posX, y: posY });
  }

  function handleDone() {
    let tempEvents = events;
    const actionPosition = PositionHelper.transformViewGamePosition(position.x, position.y, currentState.entities);
    tempEvents.edit.x = actionPosition.x;
    tempEvents.edit.y = actionPosition.y;
    if (panel.options?.positionBasedRegion) {
      const entityId = events.edit.entityId;
      const eventEntity = currentState.entities.find((ent) => ent.entityId === entityId);
      const region = PositionHelper.getRegion(actionPosition.x, actionPosition.y, sport);
      const eventRegion = eventEntity.isHome
        ? region === "P1" || region === "C1"
          ? "2pt"
          : "3pt"
        : region === "P2" || region === "C2"
          ? "2pt"
          : "3pt";
      tempEvents.edit.eventType = eventRegion;
    } else {
      tempEvents.edit.eventType = events.edit.eventType === "2pt" ? "3pt" : "2pt";
    }
    tempEvents.edit = checkAllowedValues(tempEvents.edit);

    updateState("events", tempEvents);
    setDoAction(true);
  }

  return (
    <React.Fragment>
      {isVisible && (
        <>
          <div className={panel.layout + " mini-location enabled-" + isEnabled} onClick={(e) => getPos(e)}>
            <div
              className="mini-location-marker"
              style={{
                top: position.y - 1.5 + "%",
                left: position.x - 1.5 + "%",
              }}
            ></div>
          </div>
          {panel.options?.needConfirmation && (
            <div className={"enabled-" + isEnabled + " mini-location-btn-done"} onClick={handleDone}>
              {formatMessage({
                id: "mini-location.save",
                defaultMessage: "Save new location",
              })}
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default injectIntl(MiniLocation);
